import Assignment from "../../../../types/functions/Assignment/Assignment";
import AssignmentItemDetails from "../../../../types/functions/Assignment/AssignmentItemDetails";

const getRemoveTooltip = (details: AssignmentItemDetails, assignment?: Assignment): string => {

    if (assignment && details.isIf) {
        return assignment.elseIf ? 'Remove IF condition and promote next ELSE IF branch' :
            'Remove IF condition and use ELSE result as output';
    }

    return details.isSingle ? 'clear assignment' : 'remove conditional assignment';
}
const getConfirmRemoveMessage = (isSingle: boolean): string => {

    return `Are you sure you want to ${isSingle ? 'clear assignment' : 'remove conditional assignment'}?`;
};

export { getRemoveTooltip, getConfirmRemoveMessage };
